export default {
    INTEGRATION_RECEIVED: 'INTEGRATION_RECEIVED',
    INTEGRATION_REMOVED: 'INTEGRATION_REMOVED',
};
